import styled from "styled-components";

interface BtnProps {
  $height?: string;
  $width?: string;
  $background?: string;
  $color?: string;
  $fontS?: string;
  $marginTop?: string;
  $disabledColor?: string;
  $disabledC?: string;
  $heightMobile?: string;
  $widthMobile?: string;
  $hoverColor?: string;
}

export const Btn = styled.button<BtnProps>`
height: ${(props) => (props.$height ? props.$height : "47px")};
width: ${(props) => props.$width || "130px"};
font-weight: 700;
background-color: ${(props) => props.$background};
color: ${(props) => props.$color ? props.$color : "var(--white)"};
font-size:  ${(props) => (props.$fontS ? props.$fontS : "14px")};
display: flex;
align-items: center;
justify-content: center;
margin-top: ${(props) => (props.$marginTop ? props.$marginTop : "0")};
  
&:disabled {
border-color:  ${(props) =>
      props.$disabledColor ? props.$disabledColor : "var(--disabled-bg)"};

    background-color: ${(props) =>
      props.$disabledColor ? props.$disabledColor : "var(--disabled-bg)"};
    color: ${(props) =>
      props.$disabledC ? props.$disabledC : "var(--disabled-btn-bg)"};
    cursor: default;
}
border: 2px solid  ${(props) => props.$background};
&:not(:disabled):hover {
    border: 2px solid ${(props) => (props.$hoverColor ? props.$hoverColor : "var(--white)")};
}

@media screen and (max-width: 767px) {
    height: ${(props) => props.$heightMobile || "47px"};
    width: ${(props) => props.$widthMobile || "100%"};
    font-size: 12px;
  }}
`;


export const ActionButton = styled.button<{ $hasOffset: boolean }>`
  position: absolute;
  right: 12px;
  top: ${props => props.$hasOffset ? "calc(50% + 16px)" : "50%"};
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 4px;
  display: flex;
  align-items: center;
  color: var(--disabled-c);
  cursor: ${props => props.disabled ? "default" : "pointer"};
  transition: color 0.2s ease;

  &:hover {
    color: ${props => !props.disabled && "var(--blue)"}; 
  }
`;

export const ArrowWrapper = styled.div<{ $isOpen: boolean }>`
  display: flex;
  flex-shrink: 0;
  transition: transform 0.35s ease;
  transform: rotate(${props => props.$isOpen ? "-90deg" : "90deg"});
`;